import { ReactNode } from "react"

import PersonEdit, { PersonProps, PersonState } from "../EntityEdit"
import PersonForm from './PersonForm'

import Modal from "../../../libs/ui/modal/Modal"
import ModalWaith from "../../../libs/ui/modal/ModalWaith"
import Radio from "../../../libs/ui/inputs/Radio"


class PersonAdd <T extends PersonProps, P extends PersonState>
    extends PersonEdit<T, P> {

    constructor (props: any) {
        super(props)

        this.state = this.getInitialState() as P

        this.toggle = this.toggle.bind(this)

        this.updateName = this.updateName.bind(this)
        this.updateCognome = this.updateCognome.bind(this)
        this.updateEmail = this.updateEmail.bind(this)
        this.updateCellulare = this.updateCellulare.bind(this)
        this.updateProfessione = this.updateProfessione.bind(this)

        this.updateSesso = this.updateSesso.bind(this)
        this.updateDataNascita = this.updateDataNascita.bind(this)
        this.updateNatoInItalia = this.updateNatoInItalia.bind(this)
        this.updateStato_nascita = this.updateStato_nascita.bind(this)
        this.updateComune_nascita = this.updateComune_nascita.bind(this)

        this.updateIndirizzoResidenza = this.updateIndirizzoResidenza.bind(this)
        this.setIndirizzo = this.setIndirizzo.bind(this)
        this.updateStreet = this.updateStreet.bind(this)
        this.updateStreet_number = this.updateStreet_number.bind(this)
        this.updateZip = this.updateZip.bind(this)
        this.updateCity = this.updateCity.bind(this)
        this.updateAllAddressParts = this.updateAllAddressParts.bind(this)

        this.getValidationError = this.getValidationError.bind(this)
        this.printError = this.printError.bind(this)

        this.clearNameError = this.clearNameError.bind(this)
        this.clearCognomeError = this.clearCognomeError.bind(this)
        this.clearEmailError = this.clearEmailError.bind(this)
        this.clearCellulareError = this.clearCellulareError.bind(this)
        this.clearProfessioneError = this.clearProfessioneError.bind(this)
        this.clearSessoError = this.clearSessoError.bind(this)
        this.clearDataNascitaError = this.clearDataNascitaError.bind(this)
        this.clearNatoInItaliaError = this.clearNatoInItaliaError.bind(this)
        this.clearComune_nascitaError = this.clearComune_nascitaError.bind(this)
        this.clearStato_nascitaError = this.clearStato_nascitaError.bind(this)
        this.clearIndirizzoResidenzaError = this.clearIndirizzoResidenzaError.bind(this)

        this.sendData = this.sendData.bind(this)
    }

    render(): ReactNode {
        const peopleRole = (this.props.peopleRole !== undefined) ? this.props.peopleRole : 'contraente'
        return (
            <>
                <div className="form-group radioOption">
                    <Radio
                        id='new_person'
                        key='new_person'
                        value={undefined}
                        checked={false}
                        callback={undefined}
                        onClick={this.toggle}
                    >
                        <span>
                            <strong>Inserisci un nuovo {peopleRole}</strong>
                        </span>
                    </Radio>

                    <Modal
                        title={'Nuovo ' + peopleRole}
                        buttonText='Salva'
                        isOpen={this.state.isOpen && !this.state.waith}
                        callBackToggle={this.toggle}
                        callBackSendData={this.sendData}
                        error={this.state.globalError}
                    >
                        <PersonForm 
                            nome={this.state.nome}
                            cognome={this.state.cognome}
                            email={this.state.email}
                            cellulare={this.state.cellulare}
                            sesso={this.state.sesso}
                            dataNascita={this.state.dataNascita}
                            natoInItalia={this.state.natoInItalia}
                            stato_nascita={this.state.stato_nascita}
                            comune_nascita={this.state.comune_nascita}
                            professione={this.state.professione}

                            indirizzoResidenza={this.state.indirizzoResidenza}
                            street={this.state.street}
                            street_number={this.state.street_number}
                            zip={this.state.zip}
                            city={this.state.city}

                            profList={this.props.profList}
                            statiList={this.props.statiList}

                            updateName={this.updateName}
                            updateCognome={this.updateCognome}
                            updateEmail={this.updateEmail}
                            updateCellulare={this.updateCellulare}
                            updateSesso={this.updateSesso}
                            updateDataNascita={this.updateDataNascita}
                            updateNatoInItalia={this.updateNatoInItalia}
                            updateStatoNascita={this.updateStato_nascita}
                            updateComuneNascita={this.updateComune_nascita}
                            updateProfessione={this.updateProfessione}

                            updateIndirizzo={this.updateIndirizzoResidenza}
                            updateStreet={this.updateStreet}
                            updateStreet_number={this.updateStreet_number}
                            updateZip={this.updateZip}
                            updateCity={this.updateCity}
                            updateAllAddressParts={this.updateAllAddressParts}

                            is_manual_address={this.state.is_manual_address}
                            updateManualSelectionCallBack={this.updateIsManualAddress}
                            
                            nomeError={this.state.nomeError}
                            cognomeError={this.state.cognomeError}
                            emailError={this.state.emailError}
                            phoneError={this.state.phoneError}
                            sessoError={this.state.sessoError}
                            dataNascitaError={this.state.dataNascitaError}
                            natoInItaliaError={this.state.natoInItaliaError}
                            comuneError={this.state.comune_nascitaError}
                            statoError={this.state.stato_nascitaError}
                            indirizzoResidenzaError={this.state.indirizzoResidenzaError}
                            profeError={this.state.profeError}
                            
                            clearNomeError={this.clearNameError}
                            clearCognomeError={this.clearCognomeError}
                            clearEmailError={this.clearEmailError}
                            clearPhoneError={this.clearCellulareError}
                            clearProfeError={this.clearProfessioneError}
                            clearSessoError={this.clearSessoError}
                            clearDataNascitaError={this.clearDataNascitaError}
                            clearNatoInItaliaError={this.clearNatoInItaliaError}
                            clearComuneError={this.clearComune_nascitaError}
                            clearStatoError={this.clearStato_nascitaError}
                            clearIndirizzoResidenzaError={this.clearIndirizzoResidenzaError}

                            expiredSessionCallbak={this.props.expiredSessionCallbak}

                            isInsert={true}
                            hideProfessione={this.props.hideProfessione}
                        />
                    </Modal>

                    <ModalWaith isOpen={this.state.waith}/>
                </div>
            </>
        )
    }

    getInitialState (props?: any) {
        return (props)
            ?    {
                    isOpen: false,
                    nome: props?.referent_first_name,
                    cognome: props?.referent_last_name,
                    email: props?.referent_email,
                    cellulare: props?.referent_phone,

                    sesso: props?.sesso,
                    dataNascita: props?.dataNascita,
                    natoInItalia: props?.natoInItalia,
                    comune_nascita: props?.comune_nascita,
                    stato_nascita: props?.stato_nascita,
                    indirizzoResidenza: props?.indirizzoResidenza,
                    professione: undefined,

                    is_manual_address: (props.is_manual_address !== undefined) ? props.is_manual_address !== undefined : false,

                    nomeError: undefined,
                    cognomeError: undefined,
                    emailError: undefined,
                    phoneError: undefined,
                    sessoError: undefined,
                    dataNascitaError: undefined,
                    natoInItaliaError: undefined,
                    comune_nascitaError: undefined,
                    stato_nascitaError: undefined,
                    indirizzoResidenzaError: undefined,
                    profeError: undefined,
                    
                    globalError: undefined,
                    waith: false
                }
            :   {
                    isOpen: false,
                    nome: undefined,
                    cognome: undefined,
                    email: undefined,
                    cellulare: undefined,

                    sesso: undefined,
                    dataNascita: undefined,
                    natoInItalia: undefined,
                    comune_nascita: undefined,
                    stato_nascita: undefined,
                    indirizzoResidenza: undefined,
                    professione: undefined,

                    is_manual_address: false,

                    nomeError: undefined,
                    cognomeError: undefined,
                    emailError: undefined,
                    phoneError: undefined,
                    sessoError: undefined,
                    dataNascitaError: undefined,
                    natoInItaliaError: undefined,
                    comune_nascitaError: undefined,
                    stato_nascitaError: undefined,
                    indirizzoResidenzaError: undefined,
                    profeError: undefined,
                    
                    globalError: undefined,
                    waith: false
                }
    }
}

export default PersonAdd